import Routes from './components/Routes';
import './App.css';

function App() {
  return <Routes />;
}

export default App;
